import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Ng2PaginationModule} from 'ng2-pagination';
import {PaginationBootstrapModule} from 'shared/pagination-bootstrap/pagination-bootstrap.module';

import {GroupsRoutingModule} from './groups-routing.module';

import {ModalConfirmationModule} from 'shared/modals/modal-confirmation/modal-confirmation.module';
import {SearchBarModule} from 'shared/search-bar/search-bar.module';
import {GroupsComponent} from './groups.component';
import {GroupsRepository} from './repositories/groups.repository';
import {GroupsService} from './services/groups.service';

@NgModule({
  imports: [
    CommonModule,
    GroupsRoutingModule,
    SearchBarModule,
    FormsModule,
    PaginationBootstrapModule,
    Ng2PaginationModule,
    ModalConfirmationModule,
  ],
  declarations: [
    GroupsComponent,
  ],
  providers: [
    GroupsService,
    GroupsRepository,
  ],
})

export class GroupsModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/groups/groups.module.ts